/* unplugin-vue-components disabled */import { render } from "./pixelArtDetails_Dialog.vue?vue&type=template&id=3f9ddd24&scoped=true"
import script from "./pixelArtDetails_Dialog.vue?vue&type=script&lang=js"
export * from "./pixelArtDetails_Dialog.vue?vue&type=script&lang=js"

import "./pixelArtDetails_Dialog.vue?vue&type=style&index=0&id=3f9ddd24&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f9ddd24"]])

export default __exports__